define(
    'viewmodels/secured/libraries/create/duplicate/name/name',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",

        "viewmodels/secured/libraries/create/duplicate/confirm/confirm"
    ],
    function (
        ViewModel,
        dataProvider,
        i19n,

        step4

        ){
        var comboBox = null;

        var vm = new ViewModel(
        {
            id: '',
            i19n: i19n,

            step4: step4,

            title: '',
            name: ko.observable(''),
            repositoryId: ko.observable(),
            repository: function () {
                if (comboBox == null)
                    return '';

                return comboBox.text();
            }
        });

        vm.activate = function () {
            vm.repositoryId('');
            vm.name('');

            vm.title = i19n.to.duplicateanexistinglibrary;
        };
        vm.attached = function () {
            var self = this;

            comboBox = $("#repositories_duplicate").kendoDropDownList({
                dataTextField: "text",
                dataValueField: "value",
                optionLabel: i19n.to.selectarepository,
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            callbacks.success([{ text: 'Default Cloud', value: '1' }]);
                            //dataProvider.libraries
                            //    .getLibraries()
                            //    .done(function (lists) {

                            //        self.isLibraryEmpty(lists.length == 0);

                            //        vm.lists(lists);

                            //        callbacks.success(vm.lists());
                            //    });
                        },
                    }
                }

            }).data("kendoDropDownList");
        };
        vm.validate = function () {
            var validator = $("#wizard-duplicate-name").kendoValidator().data("kendoValidator");

            if (validator.validate()) {

                vm.step4.name(vm.name());
                vm.step4.repositoryId(vm.repositoryId());
                vm.step4.repository(vm.repository());

            } else {
                return false;
            }

            return true;
        };

        return vm;
    }
);
